import { Dispatch, SetStateAction, createContext } from 'react';

export const OrderContext = createContext({
    orderTotal: null as null | number,
    setOrderTotal: (null as unknown) as Dispatch<SetStateAction<null | number>>,
});
